<div class="main formscustom">
  <div *ngIf="!myProfile" class="d-flex mb-3 back align-items-center">
    <img class="cursor gb" src="assets/images/arrow-circle-left.svg">
    <h3 class="ms-2 mb-0 cursor">Back</h3>
  </div>
  <div Class="row m-0 ">
    <div class="col-lg-2 p-0 profile mt-0 position-relative">
      <app-profile-front-page></app-profile-front-page>
    </div>

    <div class="col-lg-7 bg-white py-3 banner ">
      <form [formGroup]="addForm" (submit)="onSubmit(addForm.value)">
        <div class="row headerbox">
          <div class="col-md-8">
            <h3 class="head3 mb-1"> {{update ?'Edit' : 'Add'}} a Machine </h3>
            <p class="subCategorylists1"> <span routerLink="/main/profile/my-listings"
                [queryParams]="{ selectedCategory: 'Machine' }" class="my-list"> My Listings /
              </span><span class="addprod"> {{update ?'Edit' : 'Add'}} a Machine</span></p>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-5 text-end mt-2 p-0">
                <h5>Featured Product</h5>
              </div>
              <div class="col-md-3  text-end">
                <div class="toggle-switch">
                  <input type="checkbox" id="toggle6" [checked]="addForm.get('is_featured')?.value === true "
                    (change)="onToggleChange($event, 'is_featured')" />
                  <label for="toggle6" class="slider"></label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" ng-app="toggleApp" ng-controller="toggleController">
            <div class="row mb-4" *ngIf="update && (duplicate != 'true')">
              <div class="col-md-3 formsinput">
                <h5> Mark as Sold Out</h5>
              </div>
              <div class="col-md-9">
                <div class="toggle-switch">
                  <input type="checkbox" id="toggle7" [checked]="addForm.get('is_sold')?.value === true "
                    (change)="onToggleChange($event, 'is_sold')" />
                  <label for="toggle7" class="slider"></label>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-3">
                <h5> Basic Details</h5>
              </div>
              <div class="col-md-9">

                <label class="custom-label">
                  Industry <span class="required-asterisk">*</span>
                </label>
                <mat-form-field appearance="fill" class="mat-select-display width100 mb-2">
                  <mat-select placeholder="" formControlName="category1_id" #select2 panelClass="s1"
                    (selectionChange)="onIndustryChange($event.value)">
                    <mat-option *ngFor="let category1 of category1" [value]="category1.id">
                      {{ category1.title }}
                    </mat-option>
                    <mat-option *ngIf="category1?.length === 0" disabled>No items available</mat-option>
                  </mat-select>
                </mat-form-field>
                <small *ngIf="submitted && addForm.controls['category1_id'].hasError('required')">
                  Industry is required
                </small>

                <label class="custom-label">
                  Category <span class="required-asterisk">*</span>
                </label>
                <mat-form-field appearance="fill" class="mat-select-display width100 mb-2" #formField>
                  <mat-select placeholder="" formControlName="category2_id" #select2 panelClass="s1"
                    (selectionChange)="onIndustryBycat2($event.value)">
                    <mat-option *ngFor="let category1 of category2" [value]="category1.id">
                      {{category1.title}}
                    </mat-option>
                    <mat-option *ngIf="category2?.length === 0" disabled>No items available</mat-option>
                  </mat-select>
                </mat-form-field>
                <small
                  *ngIf="submitted && addForm.controls['category2_id']?.invalid && addForm.controls['category2_id']?.touched">
                  Category is required.
                </small>
                <!-- <small *ngIf="submitted && addForm.controls['category2_id']?.errors?.required">Category is
                  required</small> -->
                <!-- <div *ngIf="catgname">
                  <label class="custom-label">
                    Category Name <span class="required-asterisk">*</span>
                  </label>
                  <div class="locateyourdata mb-2">
                    <input type="text" appAlphaNumOnly maxlength="30" class="w-100 locationdata form-control"
                      formControlName="category2_name" placeholder="">
                  </div>
                  <small *ngIf="submitted &&  addForm.controls['category2_name'].hasError('required')">
                    Category Name is required
                  </small>
                </div> -->
                <label class="custom-label">
                  Sub-Category <span class="required-asterisk">*</span>
                </label>
                <mat-form-field appearance="fill" class="mat-select-display width100 mb-2" #formField>
                  <mat-select placeholder="" formControlName="category3_id" #select2 panelClass="s1"
                    (selectionChange)="onSubcategory3($event.value)">
                    <mat-option *ngFor="let category1 of category3" [value]="category1.id">
                      {{category1.title}}
                    </mat-option>
                    <mat-option *ngIf="category3?.length === 0" disabled>No items available</mat-option>
                  </mat-select>
                </mat-form-field>
                <small *ngIf="submitted && addForm.controls['category3_id']?.errors?.required">Sub-Category is
                  required</small>
                <div *ngIf="subcatgname">
                  <label class="custom-label">
                    Sub Category Name <span class="required-asterisk">*</span>
                  </label>
                  <div class="locateyourdata mb-2">
                    <input type="text" appAlphaNumOnly maxlength="30" class="w-100 locationdata form-control"
                      formControlName="category3_name" placeholder="">
                  </div>
                  <small *ngIf="submitted && addForm.controls['category3_name'].hasError('required')">
                    Sub Category Name is required
                  </small>
                </div>
                <div>
                  <label class="custom-label">
                    Title <span class="required-asterisk">*</span>
                  </label>
                  <div class="locateyourdata mb-2">
                    <input type="text" appAlphaNumOnly maxlength="30" class="w-100 locationdata form-control"
                      formControlName="sub_title" placeholder="">
                  </div>
                  <small *ngIf="submitted && addForm.controls['sub_title'].hasError('required')">
                    Title field is required
                  </small>
                </div>
                <div *ngFor="let field of dynamicFields" class="width100 mb-2 newslect custom-select-wrapper">
                  <label  *ngIf="!(field === 'atc' && selectedValues['is_atc'] !== 'Yes')" class="custom-label">{{ transformLabel(field) }} <span class="required-asterisk">*</span></label>
                  
                  <!-- Hide the ATC Key dropdown when is_atc is "No" -->
                  <div *ngIf="!(field === 'atc' && selectedValues['is_atc'] !== 'Yes')">
                    <select [(ngModel)]="selectedValues[field]" [ngModelOptions]="{ standalone: true }"
                      (change)="onSelectionChange(field, $event)" class="custom-select">
                      <option value="" disabled>Select</option>
                      <option *ngFor="let item of dropdownOptions[field]" [value]="item">
                        {{ item }}
                      </option>
                      <option *ngIf="!dropdownOptions[field]?.length" disabled>No items available</option>
                    </select>
                  </div>
                </div>
                
                <!-- <div *ngFor="let field of dynamicFields" class="width100 mb-2 newslect custom-select-wrapper">
                  <label class="custom-label">{{ transformLabel(field) }} <span class="required-asterisk">*</span></label>
                  <select [(ngModel)]="selectedValues[field]" [ngModelOptions]="{standalone: true}"
                    (change)="onSelectionChange(field, $event)" class="custom-select">
                    <option value="" disabled>Select</option>
                    <option *ngFor="let item of dropdownOptions[field]" [value]="item">
                      {{ item }}
                    </option>
                    <option *ngIf="!dropdownOptions[field]?.length" disabled>No items available</option>
                  </select>
                </div> -->
                <!-- {{toolspecify | json}} -->
                <div *ngIf="toolspecify">
                  <label class="custom-label">
                    Specification (max words: 500) <span class="required-asterisk">*</span>
                  </label>
                  <div class="customwidth position-relative mb-2 textarea-container">
                    <textarea type="text" class="form-control emaildata ps-3" formControlName="highlights"
                      maxlength="500" placeholder=""></textarea>
                  </div>
                  <small *ngIf="submitted && addForm.controls['highlights']?.errors?.required">Highlights is
                    required</small>
                </div>


                <label class="custom-label">
                  Additional key features (max words: 500) <span class="required-asterisk">*</span>
                </label>
                <div class="customwidth position-relative mb-2 textarea-container">
                  <textarea type="text" class="form-control emaildata ps-3" formControlName="description"
                    maxlength="500" placeholder=""></textarea>
                  <small *ngIf="submitted && addForm.controls['description']?.errors?.required">Additional key features
                    is
                    required</small>
                </div>
                <label class="custom-label">
                  Brand <span class="required-asterisk">*</span>
                </label>
                <mat-form-field appearance="fill" class="mat-select-display width100 mb-2" #formField>
                  <mat-select placeholder="" #select2 formControlName="brand_id"
                    (selectionChange)="onBrandselect($event.value)" [disableOptionCentering]="true"
                    (closed)="clearSearch(searchbrand)">
                    <div class="search-containers" mat-select-trigger>
                      <mat-form-field appearance="standard" class="search-field searchborder">
                        <input matInput placeholder="Search Brand" #searchbrand (input)="filterBrand(searchbrand.value)"
                          (click)="$event.stopPropagation()" class="ms-2" />
                      </mat-form-field>
                    </div>
                    <mat-option *ngFor="let industry1 of filteredBrandData" [value]="industry1.id">
                      {{industry1.brand_name}}
                    </mat-option>
                    <mat-option *ngIf="industry?.length == 0" disabled>No items
                      available</mat-option>
                  </mat-select>
                </mat-form-field>
                <small *ngIf="submitted && addForm.controls['brand_id'].invalid" class="">
                  <small *ngIf="submitted && addForm.controls['brand_id']?.errors?.required">Brand is
                    required</small>
                </small>
                <div *ngIf="brandname">
                  <label class="custom-label">
                    Brand Name <span class="required-asterisk">*</span>
                  </label>
                  <div class="locateyourdata mb-2">
                    <input type="text" appAlphaNumOnly maxlength="30" class="w-100 locationdata form-control"
                      formControlName="brand_name" placeholder="">
                  </div>
                  <small *ngIf="submitted && addForm.controls['brand_name'].hasError('required')">
                    Brand Name is required
                  </small>
                </div>
                <!-- <label class="custom-label">
                  Country Origin   <span *ngIf="!isCountryReadonly" class="required-asterisk">*</span>

                </label>
                <div class="locateyourdata mb-2">
                  <input type="text" class="w-100 locationdata form-control" formControlName="country_origin"
                    placeholder="" [readonly]="isCountryReadonly" maxlength="60">
                </div>
                <small *ngIf="submitted && addForm.controls['country_origin'].hasError('required')">
                  Country Origin is required
                </small> -->
                <label class="custom-label">
                  Country Origin   <span *ngIf="!isCountryReadonly" class="required-asterisk">*</span>
                </label>
                <mat-form-field appearance="fill" class="mat-select-display width100 mb-2">
                  <mat-select placeholder="" formControlName="country_origin" [disabled]="isCountryReadonly" #select2 panelClass="s1"
                    >
                    <div class="search-containers" mat-select-trigger>
                      <mat-form-field appearance="standard" class="search-field searchborder">
                        <input matInput placeholder="Search Country" #searchCountry (input)="filteredCountries(searchCountry.value)"
                          (click)="$event.stopPropagation()" class="ms-2" />
                      </mat-form-field>
                    </div>
                    <mat-option *ngFor="let country of filteredCountriesData" [value]="country.name">
                      {{ country.name }}
                    </mat-option>
                    <mat-option *ngIf="countriesList?.length === 0" disabled>No items available</mat-option>
                  </mat-select>
                </mat-form-field>
                <small *ngIf="submitted && addForm.controls['country_origin'].hasError('required')">
                  Country origin is required
                </small>

                <div class="row d-flex">
                  <!-- <div class="col-md-12 mb-2"> -->
                  <!-- <div class="d-flex  row locateyourdata align-items-center"> -->
                  <div class="col-md-6 mb-2">
                    <label class="custom-label">
                      Model Number
                    </label>
                    <div class="locateyourdata ">
                      <input type="text" appAlphaNumOnly maxlength="10" class="w-100 locationdata form-control"
                        formControlName="model_number" placeholder="">
                    </div>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="custom-label">
                      Make Year <span class="required-asterisk">*</span>
                    </label>
                    <mat-form-field appearance="fill" style="width: 100%">
                      <input matInput [matDatepicker]="endDate" [max]="maxDate" readonly
                        formControlName="manufacturing_year" />
                      <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                      <mat-datepicker #endDate startView="multi-year"
                        (yearSelected)="chosenYearHandler($event, endDate)" panelClass="example-year-picker">
                      </mat-datepicker>
                    </mat-form-field>
                    <small *ngIf="submitted && addForm.controls['manufacturing_year'].hasError('required')">
                      Make Year is required
                    </small>
                  </div>
                </div>
                <!-- </div> -->
                <!-- </div> -->
                <div class="row">
                  <div class="col-md-6 locateyourdata">
                    <label class="custom-label">
                      Automation Level
                    </label>
                    <mat-form-field appearance="fill" class="mat-select-display width100 mb-2">
                      <mat-select placeholder="" formControlName="automation_level" #select2 panelClass="s1">
                        <mat-option value="">None</mat-option>
                        <mat-option *ngFor="let category1 of alldropdown?.automation_level"
                          [value]="category1.master_id">
                          {{category1.master_value}}
                        </mat-option>
                        <mat-option *ngIf="alldropdown?.automation_level.length === 0" disabled>No items
                          available</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-md-6 locateyourdata">
                    <label class="custom-label">
                      Condition <span class="required-asterisk">*</span>
                    </label>
                    <mat-form-field appearance="fill" class="mat-select-display width100 mb-2">
                      <mat-select placeholder="" formControlName="product_condition" #select2 panelClass="s1"
                        (selectionChange)="onCondition($event.value)">
                        <mat-option *ngFor="let category1 of alldropdown?.condition" [value]="category1.master_value">
                          {{category1.master_value}}
                        </mat-option>
                        <mat-option *ngIf="alldropdown?.condition.length === 0" disabled>No items
                          available</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <small *ngIf="submitted && addForm.controls['product_condition'].hasError('required')">
                      Condition is required
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-3">
                <h5>Price</h5>
              </div>
              <div class="col-md-9 formsinput">
                <div class="row d-flex align-items-center">
                  <div class="col-md-5">
                    <label class="custom-label">
                      Select Type <span class="required-asterisk">*</span>
                    </label>
                    <mat-form-field appearance="fill" class="mat-select-display width100 mb-2">
                      <mat-select placeholder="" formControlName="price_type" #select2 panelClass="s1">
                        <mat-option *ngFor="let category1 of alldropdown?.price" [value]="category1.master_id">
                          {{category1.master_value}}
                        </mat-option>
                        <mat-option *ngIf="alldropdown?.price.length === 0" disabled>No items available</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <small *ngIf="submitted && addForm.controls['price_type'].hasError('required')">
                      Price type is required
                    </small>
                  </div>
                  <div class="col-md-5">
                    <label class="custom-label">
                      Enter Price <span class="required-asterisk">*</span>
                    </label>
                    <div class="locateyourdata pricefield">
                      <img src="assets/images/new_img/rupee.svg" class="rupee" alt="rupee">

                      <input type="text" numeric maxlength="10" class="w-100 locationdata form-control mb-2"
                        formControlName="price" placeholder="" style="padding-left: 60px;"
                        (keypress)="handleKeyPress($event)">
                    </div>
                    <small *ngIf="submitted && addForm.controls['price']?.errors?.required">Price is
                      required</small>
                  </div>
                  <div class="col-md-2 ">
                    <label class="custom-label">Inclusive GST </label>
                    <!-- <div class="d-flex align-items-center justify-content-end"> -->
                    <div class="toggle-switch">
                      <input type="checkbox" id="toggle" [checked]="addForm.get('gst_inclusive')?.value === 'yes'"
                        (change)="onToggleChange($event, 'gst_inclusive')" />
                      <label for="toggle" class="slider"></label>
                    </div>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>


            <div class="row mt-4">
              <div class="col-md-3">
                <h5>Upload Media (max: 5)<span class="required-asterisk"> *</span></h5>
                <p> Supported Formats: <span style="opacity: 50%;" class="mediatype">jpg,.jpeg,.png,.mp4,.gif,.webp,.jfif (upto 10
                    MB)</span></p>
              </div>
              <div class="col-md-9 formsinput">
                <div class="drop-area" (dragover)="onDragOver($event)" (drop)="onDrop($event)"
                  (dragleave)="onDragLeave($event)">
                  <div class="">
                    <div class="uploaddesignbox">
                      <img src="assets/images/new_img/uplaod.svg" class="" alt="Drag or Upload a File">
                      <p>Drag or Upload a File</p>
                    </div>
                    <div class="dragbox">
                      <input type="file" id="fileUpload" (change)="onFileChangedemo($event)" multiple
                        accept=".jpg,.jpeg,.png,.mp4,.gif,.webp,.jfif" style="opacity: 0;" />
                    </div>
                  </div>
                </div>
                <div *ngIf="errorMessages" class="error-messages">
                  <div *ngFor="let message of errorMessages">{{ message }}</div>
                </div>
                <div class="row">
                  <div class="col-md-2" *ngFor="let file of addForm.get('media')?.value; let i = index">
                    <div class="previewbox">

                      <div *ngIf="file.url?.endsWith('.mp4')" class="d-flex">
                        <video width="100%" height="114px" class="videoBackground" controls>
                          <source [src]="file.url" type="video/mp4" />
                          Your browser does not support the video tag.
                        </video>
                        <span class="closebox" (click)="removeFile(i)">
                          <img src="assets/images/new_img/close-round.svg" class="" alt="close-round">
                        </span>
                      </div>
                      <span *ngIf="file.url && !file.url.endsWith('.mp4')">
                        <span class="closebox" (click)="removeFile(i)">
                          <img src="assets/images/new_img/close-round.svg" class="" alt="close-round">
                        </span>
                        <img [src]="file.url" alt="Uploaded Image"
                          style="width: 100%; min-height: 114px ;max-height: 114px;" />
                      </span>

                    </div>
                  </div>
                </div>
                <small *ngIf="submitted && addForm.controls['media']?.errors?.required">Media is
                  required</small>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-3">
                <h5>Number of Units Available</h5>
              </div>
              <div class="col-md-9 formsinput">
                <label class="custom-label">
                  Enter Number of Units <span class="required-asterisk">*</span>
                </label>
                <div class="locateyourdata mb-2">
                  <input type="text" class="w-100 locationdata form-control" formControlName="number_units_available"
                    placeholder="" maxlength="10" (keypress)="handleKeyPress($event)">
                </div>
                <small *ngIf="submitted && addForm.controls['number_units_available']?.errors?.required">Number of units
                  available is
                  required</small>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-3">
                <h5>Machine`s Location</h5>
              </div>
              <div class="col-md-9 formsinput">
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="custom-label">
                      State <span class="required-asterisk">*</span>
                    </label>
                    <div class="locateyourdata ">
                      <mat-form-field appearance="fill" class="mat-select-display width100 mb-2">
                        <mat-select placeholder="" formControlName="state" (selectionChange)="onStateChange($event)"
                          (closed)="clearSearch(searchInput)" #select2 panelClass="s1" [disableOptionCentering]="true">
                          <div class="search-containers" mat-select-trigger>
                            <mat-form-field appearance="standard" class="search-field searchborder">
                              <input matInput placeholder="Search State" #searchInput class="ms-2"
                                (input)="filterStates(searchInput.value)" (click)="$event.stopPropagation()" />
                            </mat-form-field>
                          </div>
                          <mat-option *ngFor="let category1 of filteredStateData" [value]="category1.id">
                            {{ category1.name }}
                          </mat-option>
                          <mat-option *ngIf="filteredStateData?.length === 0" disabled>
                            No items available
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <small *ngIf="submitted && addForm.controls['state']?.errors?.required">State
                      is
                      required</small>
                  </div>
                  <div class="col-md-6 mb-2" *ngIf="cityData?.length > 0">
                    <label class="custom-label col-md-12">
                      City <span class="required-asterisk">*</span>
                    </label>
                    <mat-form-field appearance="fill" class="mat-select-display width100 mb-2">
                      <mat-select placeholder="" formControlName="city" (selectionChange)="onCityChange($event)"
                        (closed)="clearSearch(searchInput)" #select2 panelClass="s1" [disableOptionCentering]="true">
                        <div class="search-containers" mat-select-trigger>
                          <mat-form-field appearance="standard" class="search-field searchborder">
                            <input matInput placeholder="Search City" #searchInput class="ms-2"
                              (input)="filterCity(searchInput.value)" (click)="$event.stopPropagation()" />
                          </mat-form-field>
                        </div>
                        <mat-option *ngFor="let category1 of filteredcityData" [value]="category1.id">
                          {{ category1.city }}
                        </mat-option>
                        <mat-option *ngIf="filteredcityData?.length === 0" disabled>
                          No items available
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <small *ngIf="submitted && addForm.controls['city']?.errors?.required">City
                      is
                      required</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-3">
                <h5>Warranty</h5>
              </div>
              <div class="col-md-9 formsinput">
                <div class="row">
                  <div class="col-md-12">
                    <div class="toggle-switch">
                      <input type="checkbox" id="toggle2" [checked]="addForm.get('warranty_available')?.value === 'yes'"
                        (change)="onToggleChange($event, 'warranty_available')" />
                      <label for="toggle2" class="slider"></label>
                    </div>
                  </div>
                  <div class="col-md-6"
                    *ngIf="addForm.controls['warranty_period'].hasError('required') || warranty == true">
                    <label class="custom-label">
                      Warranty Period (Months) <span class="required-asterisk">*</span>
                    </label>
                    <div class="locateyourdata mb-2">
                      <input type="text" class="w-100 locationdata form-control" formControlName="warranty_period"
                        placeholder="" maxlength="3" (keypress)="handleKeyPress($event)">
                    </div>
                    <small *ngIf="addForm.controls['warranty_period'].hasError('required')">
                      Warranty period is required when warranty is available.
                    </small>
                  </div>
                </div>
                <label class=" custom-label">
                  Coverage Details
                </label>
                <div class="locateyourdata mb-2">
                  <input type="text" class="w-100 locationdata form-control" formControlName="coverage_details"
                    placeholder="" maxlength="250">
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-3">
                <h5> After Sales Service</h5>
              </div>
              <div class="col-md-9 formsinput">
                <label class="custom-label">
                  Enter Service
                </label>
                <div class="locateyourdata mb-2">
                  <input type="text" class="w-100 locationdata form-control" formControlName="after_sale_service"
                    placeholder="" maxlength="150">
                </div>
                <!-- <small *ngIf="submitted && addForm.controls['after_sale_service']?.errors?.required">After sale
                  service
                  is
                  required</small> -->
              </div>
            </div>
            <div class="row mt-4" *ngIf="hypo">
              <div class="col-md-3">
                <h5> Hypothecation</h5>
              </div>
              <div class="col-md-9 formsinput">
                <div class="toggle-switch">
                  <input type="checkbox" id="toggle3" [checked]="addForm.get('under_hypothecation')?.value === 'yes'"
                    (change)="onToggleChange($event, 'under_hypothecation')" />
                  <label for="toggle3" class="slider"></label>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-3">
                <h5> Bulk Order Provision</h5>
              </div>
              <div class="col-md-9 formsinput">
                <div class="toggle-switch">
                  <input type="checkbox" id="toggle4" [checked]="addForm.get('bulk_order_provision')?.value === 'yes'"
                    (change)="onToggleChange($event, 'bulk_order_provision')" />
                  <label for="toggle4" class="slider"></label>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-3">
                <h5> Offer Applicable</h5>
              </div>
              <div class="col-md-9 formsinput">
                <!-- <div class="d-flex align-items-center justify-content-end row"> -->
                <div class="col-md-12">
                  <div class="toggle-switch">
                    <input type="checkbox" id="toggle5"
                      [checked]="addForm.controls['offer_applicable']?.value === 'yes'"
                      (change)="onToggleChange($event, 'offer_applicable')" />
                    <label for="toggle5" class="slider"></label>
                  </div>
                </div>
                <div class="w-100 col-md-10" *ngIf="offer == true">
                  <label class="custom-label">
                    Offer Details <span class="required-asterisk">*</span>
                  </label>
                  <div class="locateyourdata mb-2">
                    <input type="text" maxlength="250" class="w-100 locationdata form-control"
                      formControlName="offer_details" placeholder="">
                  </div>
                  <small *ngIf="submitted && addForm.controls['offer_details']?.errors?.required">Offer Details
                    is
                    required</small>
                  <!-- Offer Validity -->
                  <label class="custom-label">
                    Offer Validity
                  </label>
                  <div class="locateyourdata mb-2">
                    <!-- <mat-form-field appearance="fill" style="width:50%">
                      <input type="date" matInput formControlName="offer_validity"
                        (change)="onOfferValidityChange($event)" class="dateinput" [min]="minDate" />
                    </mat-form-field> -->
                    <mat-form-field appearance="fill" style="width:50%">
                      <input type="date" matInput [value]="getInputDateValue()" (change)="onOfferValidityChange($event)"
                        class="dateinput" [min]="minDate" />
                    </mat-form-field>


                  </div>

                </div>
                <!-- </div> -->

              </div>
            </div>
            <div class="row mt-4">
              <div class="col-md-3">
                <h5>Annual Maintenance Contract (AMC)</h5>
              </div>
              <div class="col-md-9 formsinput">
                <label class="custom-label">
                  Enter Number (in Years)
                </label>
                <div class="locateyourdata mb-2">
                  <input type="text" maxlength="10" class="w-100 locationdata form-control" formControlName="AMC"
                    placeholder="" (keypress)="handleKeyPress($event)">
                </div>

              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-3">
                <h5>Service Level Agreement (SLA)</h5>
              </div>
              <div class="col-md-9 formsinput">
                <label class="custom-label">
                  Enter Number (in months)
                </label>
                <div class="locateyourdata mb-2">
                  <input type="text" maxlength="10" class="w-100 locationdata form-control" formControlName="SLA"
                    placeholder="" (keypress)="handleKeyPress($event)">
                </div>
              </div>
            </div>
            <div class="d-flex btnbox justify-content-between mt-3">
              <button type="button" class="discard" name="discard" (click)="discard()">Discard </button>
              <button type="submit" *ngIf="add" class="addListing" name="addListing">Add
                Listing </button>
              <button type="submit" *ngIf="update" class="addListing">Update
                Listing</button>
              <button type="submit" *ngIf="duplicate" class="addListing" name="addListing">Update
                Listing </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- Loop through dynamic fields to create dropdowns -->
<!-- <div *ngFor="let field of dynamicFields">
                  <mat-form-field appearance="fill" class="mat-select-display width100 mb-2">
                    <mat-label>{{ field }}</mat-label>
                    <mat-select [placeholder]="field" [value]="addForm.get('specifications')?.value[field]"
                      (selectionChange)="onSelectionChange(field, $event.value)">
                      <mat-option *ngFor="let item of specification" [value]="item[field]">
                        {{ item[field] }}
                      </mat-option>
                      <mat-option *ngIf="!specification?.length" disabled>No items available</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div> -->
<!-- <label class="custom-label">{{ field }}</label>
                <mat-form-field appearance="fill" class="mat-select-display width100 mb-2">
                  <mat-select [(value)]="selectedValues[field]" (change)="onSelectionChange(field, $event)">
                    <mat-option value="">Select</mat-option>
                    <mat-option *ngFor="let item of dropdownOptions[field]" [value]="item">
                      {{ item }}
                    </mat-option>
                  </mat-select>
                </mat-form-field> -->
<!-- </mat-form-field> -->
<!-- <mat-form-field appearance="fill" class="mat-select-display width100 mb-2">
                    <mat-label>{{ field }}</mat-label>
                    <mat-select
                      [placeholder]="field"
                      [(value)]="addForm.get('specifications')?.value[field]"
                      (selectionChange)="onSelectionChange(field, $event.value)">
                      <mat-option *ngFor="let item of specification" [value]="item[field]">
                        {{ item[field] }}
                      </mat-option>
                      <mat-option *ngIf="!specification?.length" disabled>No items available</mat-option>
                    </mat-select>
                  </mat-form-field> -->

<!-- <label class="custom-label">
                  Title <span class="required-asterisk">*</span>
                </label>
                <div class="locateyourdata mb-2">
                  <input type="text" appAlphaNumOnly maxlength="30" class="w-100 locationdata form-control"
                    formControlName="title" placeholder="">
                </div>
                <small *ngIf="submitted && addForm.controls['title']?.errors?.required">Title is
                  required</small> -->

<!-- <mat-form-field appearance="fill" style="width:100%" class="">
                        <input matInput [matDatepicker]="manufacturing_year" placeholder="" readonly
                          formControlName="manufacturing_year" />
                        <mat-datepicker-toggle matSuffix [for]="manufacturing_year"></mat-datepicker-toggle>
                        <mat-datepicker #manufacturing_year startView="multi-year"
                          (yearSelected)="chosenYearHandler($event, manufacturing_year)"
                          panelClass="example-year-picker"></mat-datepicker>
                      </mat-form-field>

                      <small *ngIf="submitted && addForm.controls['manufacturing_year']?.errors?.required">Manufacturing
                        Year is
                        required</small> -->
<!-- <div class="row mt-4">
              <div class="col-md-3">
                <h5>Specifications</h5>
              </div>
              <div class="col-md-9 formsinput">
                <div class="customwidth position-relative mb-2 textarea-container">
                  <label class="custom-label">
                    Highlights (max words: 1500) <span class="required-asterisk">*</span>
                  </label>
                  <textarea type="text" class="form-control emaildata ps-3" formControlName="highlights"
                    maxlength="1500" placeholder=""></textarea>
                </div>
                <small *ngIf="submitted && addForm.controls['highlights']?.errors?.required">Highlights is
                  required</small>
                <div class="row">
                  <div class="col-md-4">
                    <label class="custom-label">
                      Length (in meter)
                    </label>
                    <div class="locateyourdata mb-2 position-relative">

                      <div class="fullbox">

                        <input type="text" class="w-100 locationdata form-control" formControlName="length"
                          placeholder="" />
                        <mat-form-field class="dropdown-inside" appearance="fill">
                          <mat-select placeholder="Unit" formControlName="lunit">
                            <mat-option value="m">Meter</mat-option>
                            <mat-option value="cm">Centimeter</mat-option>
                            <mat-option value="km">Kilometer</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="custom-label">
                      Width (in meter)
                    </label>
                    <div class="locateyourdata mb-2 position-relative">
                      <div class="fullbox">

                        <input type="text" class="w-100 locationdata form-control" formControlName="width"
                          placeholder="">

                        <mat-form-field class="dropdown-inside" appearance="fill">
                          <mat-select placeholder="Unit" formControlName="wunit">
                            <mat-option value="m">Meter</mat-option>
                            <mat-option value="cm">Centimeter</mat-option>
                            <mat-option value="km">Kilometer</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="custom-label">
                      Height (in meter)
                    </label>
                    <div class="locateyourdata mb-2 position-relative">
                      <div class="fullbox">

                        <input type="text" class="w-100 locationdata form-control" formControlName="height"
                          placeholder="">

                        <mat-form-field class="dropdown-inside" appearance="fill">
                          <mat-select placeholder="Unit" formControlName="hunit">
                            <mat-option value="m">Meter</mat-option>
                            <mat-option value="cm">Centimeter</mat-option>
                            <mat-option value="km">Kilometer</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
                <label class="custom-label">
                  Capacity
                </label>
                <div class="d-flex">
                  <div class="locateyourdata w-100 mb-2 me-2 position-relative">
                    <div class="fullbox">

                      <input type="text" appAlphaNumOnly class="w-100 locationdata form-control"
                        formControlName="capacity" placeholder="">

                      <mat-form-field class="dropdown-inside" appearance="fill">
                        <mat-select placeholder="Unit" formControlName="cunit">
                          <mat-option value="m">Meter</mat-option>
                          <mat-option value="cm">Centimeter</mat-option>
                          <mat-option value="km">Kilometer</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="custom-label">
                      Power Consumption (KW) <span class="required-asterisk">*</span>
                    </label>
                    <div class="locateyourdata ">
                      <input type="text" class="w-100 locationdata form-control" formControlName="power_consumption"
                        placeholder="">
                    </div>
                    <small *ngIf="submitted && addForm.controls['power_consumption']?.errors?.required">Power
                      consumption is
                      required</small>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="custom-label">
                      Operating Temperature <span class="required-asterisk">*</span>
                    </label>
                    <div class="locateyourdata ">
                      <input type="text" class="w-100 locationdata form-control" formControlName="operating_temp"
                        placeholder="">
                    </div>
                    <small *ngIf="submitted && addForm.controls['operating_temp']?.errors?.required">Operating temp is
                      required</small>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="custom-label">
                      Noise Level (dB) <span class="required-asterisk">*</span>
                    </label>
                    <div class="locateyourdata ">
                      <input type="text" class="w-100 locationdata form-control" formControlName="noise_level"
                        placeholder="">
                    </div>
                    <small *ngIf="submitted && addForm.controls['noise_level']?.errors?.required">Noise level is
                      required</small>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="custom-label">
                      Precision / Tolerance
                    </label>
                    <div class="locateyourdata ">
                      <input type="text" class="w-100 locationdata form-control" formControlName="precision"
                        placeholder="">
                    </div>
                  </div>
                </div>
                <label class="custom-label">
                  Condition <span class="required-asterisk">*</span>
                </label>
                <mat-form-field appearance="fill" class="mat-select-display width100 mb-2">
                  <mat-select placeholder="" formControlName="product_condition" #select2 panelClass="s1"
                    (selectionChange)="onCondition($event.value)">
                    <mat-option *ngFor="let category1 of alldropdown?.condition" [value]="category1.master_id">
                      {{category1.master_value}}
                    </mat-option>
                    <mat-option *ngIf="alldropdown?.condition.length === 0" disabled>No items available</mat-option>
                  </mat-select>

                </mat-form-field>
                <small *ngIf="submitted && addForm.controls['product_condition'].hasError('required')">
                  Condition is required
                </small>
              </div>
            </div> -->
<!-- <label class="custom-label">
                    Offer Validity
                  </label>
                  <div class="locateyourdata mb-2">
                    <mat-form-field appearance="fill" style="width:100%" class="">
                      <input matInput [matDatepicker]="offer_validity" placeholder="" readonly
                        formControlName="offer_validity" />
                      <mat-datepicker-toggle matSuffix [for]="offer_validity"></mat-datepicker-toggle>
                      <mat-datepicker #offer_validity startView="multi-year"
                        (yearSelected)="chosenofferHandler($event, offer_validity)"
                        panelClass="example-year-picker"></mat-datepicker>
                    </mat-form-field>
                  </div> -->
<!-- <div class="row mt-4">
              <div class="col-md-3">
                <h5>Specifications</h5>
              </div>
              <div class="col-md-9 formsinput">
                <div class="customwidth position-relative mb-2 textarea-container">
                  <label class="custom-label">
                    Highlights (max words: 1500) <span class="required-asterisk">*</span>
                  </label>
                  <textarea type="text" class="form-control emaildata ps-3" formControlName="highlights"
                    maxlength="1500" placeholder=""></textarea>
                </div>
                <small *ngIf="submitted && addForm.controls['highlights']?.errors?.required">Highlights is
                  required</small>
                <div class="row">
                  <div class="col-md-4">
                    <label class="custom-label">
                      Length (in meter)
                    </label>
                    <div class="locateyourdata mb-2 position-relative">

                      <div class="fullbox">

                        <input type="text" class="w-100 locationdata form-control" formControlName="length"
                          placeholder="" />
                        <mat-form-field class="dropdown-inside" appearance="fill">
                          <mat-select placeholder="Unit" formControlName="lunit">
                            <mat-option value="m">Meter</mat-option>
                            <mat-option value="cm">Centimeter</mat-option>
                            <mat-option value="km">Kilometer</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="custom-label">
                      Width (in meter)
                    </label>
                    <div class="locateyourdata mb-2 position-relative">
                      <div class="fullbox">

                        <input type="text" class="w-100 locationdata form-control" formControlName="width"
                          placeholder="">
                        
                        <mat-form-field class="dropdown-inside" appearance="fill">
                          <mat-select placeholder="Unit" formControlName="wunit">
                            <mat-option value="m">Meter</mat-option>
                            <mat-option value="cm">Centimeter</mat-option>
                            <mat-option value="km">Kilometer</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <label class="custom-label">
                      Height (in meter)
                    </label>
                    <div class="locateyourdata mb-2 position-relative">
                      <div class="fullbox">

                        <input type="text" class="w-100 locationdata form-control" formControlName="height"
                          placeholder="">
                       
                        <mat-form-field class="dropdown-inside" appearance="fill">
                          <mat-select placeholder="Unit" formControlName="hunit">
                            <mat-option value="m">Meter</mat-option>
                            <mat-option value="cm">Centimeter</mat-option>
                            <mat-option value="km">Kilometer</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
                <label class="custom-label">
                  Capacity
                </label>
                <div class="d-flex">
                  <div class="locateyourdata w-100 mb-2 me-2 position-relative">
                    <div class="fullbox">

                      <input type="text" appAlphaNumOnly class="w-100 locationdata form-control"
                        formControlName="capacity" placeholder="">
                      
                      <mat-form-field class="dropdown-inside" appearance="fill">
                        <mat-select placeholder="Unit" formControlName="cunit">
                          <mat-option value="m">Meter</mat-option>
                          <mat-option value="cm">Centimeter</mat-option>
                          <mat-option value="km">Kilometer</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="custom-label">
                      Power Consumption (KW) <span class="required-asterisk">*</span>
                    </label>
                    <div class="locateyourdata ">
                      <input type="text" class="w-100 locationdata form-control" formControlName="power_consumption"
                        placeholder="">
                    </div>
                    <small *ngIf="submitted && addForm.controls['power_consumption']?.errors?.required">Power
                      consumption is
                      required</small>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="custom-label">
                      Operating Temperature <span class="required-asterisk">*</span>
                    </label>
                    <div class="locateyourdata ">
                      <input type="text" class="w-100 locationdata form-control" formControlName="operating_temp"
                        placeholder="">
                    </div>
                    <small *ngIf="submitted && addForm.controls['operating_temp']?.errors?.required">Operating temp is
                      required</small>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <label class="custom-label">
                      Noise Level (dB) <span class="required-asterisk">*</span>
                    </label>
                    <div class="locateyourdata ">
                      <input type="text" class="w-100 locationdata form-control" formControlName="noise_level"
                        placeholder="">
                    </div>
                    <small *ngIf="submitted && addForm.controls['noise_level']?.errors?.required">Noise level is
                      required</small>
                  </div>
                  <div class="col-md-6 mb-2">
                    <label class="custom-label">
                      Precision / Tolerance
                    </label>
                    <div class="locateyourdata ">
                      <input type="text" class="w-100 locationdata form-control" formControlName="precision"
                        placeholder="">
                    </div>
                  </div>
                </div>
                <label class="custom-label">
                  Condition <span class="required-asterisk">*</span>
                </label>
                <mat-form-field appearance="fill" class="mat-select-display width100 mb-2">
                  <mat-select placeholder="" formControlName="product_condition" #select2 panelClass="s1"
                    (selectionChange)="onCondition($event.value)">
                    <mat-option *ngFor="let category1 of alldropdown?.condition" [value]="category1.master_id">
                      {{category1.master_value}}
                    </mat-option>
                    <mat-option *ngIf="alldropdown?.condition.length === 0" disabled>No items available</mat-option>
                  </mat-select>
                  
                </mat-form-field>
                <small *ngIf="submitted && addForm.controls['product_condition'].hasError('required')">
                  Condition is required
                </small>
              </div>
            </div> -->